export { default } from './PartnerProgramCard';
